export const SmallLogoBlackFriday = () => (
  <svg
    id="Lager_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 238.77 39.98"
    width="134"
    height="27"
  >
    <g id="Lager_1-2">
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M46.78,30.21v2.57h-2.93V6.94h3.1v9.4c.53-1.23,2.1-2.53,4.93-2.53,3.77,0,6.1,2.6,6.1,7.26v4.67c0,4.77-2.33,7.33-6.1,7.33-3.03,0-4.3-1.3-5.1-2.87ZM54.85,25.34v-3.83c0-3.23-1.33-5.1-3.97-5.1-2.47,0-3.93,1.7-3.93,4.93v4c0,3.37,1.4,5.17,3.93,5.17s3.97-1.83,3.97-5.17Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M62.13,39.87l2.53-7.2-6.4-18.63h3.47l4.56,14.43,4.6-14.43h3.4l-8.93,25.83h-3.23Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M74.65,25.74v-4.67c0-4.57,2.27-7.2,5.76-7.2,2.83,0,4.83,1.3,5.4,2.77v-2.6h2.93v18.9c0,4.5-1.57,6.93-7,6.93s-6.87-2.73-6.87-5.6h3.03c0,1.6,1.03,3.13,3.83,3.13s3.9-1.3,3.9-3.83v-3.37c-.53,1.27-2.06,2.87-4.93,2.87-3.73,0-6.07-2.6-6.07-7.33ZM85.65,25.61v-4.76c0-2.97-1.53-4.47-3.93-4.47-2.57,0-3.93,1.77-3.93,5.1v3.97c0,3.4,1.33,5.17,3.93,5.17s3.93-1.67,3.93-5Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M90.85,25.74v-4.67c0-4.57,2.27-7.2,5.77-7.2,2.83,0,4.83,1.3,5.4,2.77v-2.6h2.93v18.9c0,4.5-1.57,6.93-7,6.93s-6.86-2.73-6.86-5.6h3.03c0,1.6,1.03,3.13,3.83,3.13s3.9-1.3,3.9-3.83v-3.37c-.53,1.27-2.07,2.87-4.93,2.87-3.73,0-6.07-2.6-6.07-7.33ZM101.85,25.61v-4.76c0-2.97-1.53-4.47-3.93-4.47-2.57,0-3.93,1.77-3.93,5.1v3.97c0,3.4,1.33,5.17,3.93,5.17,2.46,0,3.93-1.67,3.93-5Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M111.6,32.77h-4.33V6.84h4.33v9.01s1.34-2.03,4.3-2.03,5.43,1.7,5.43,6.73v12.23h-4.37v-10.56c0-3.1-.47-4.47-2.7-4.47-1.83,0-2.67.97-2.67,3.37v11.66Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M137.21,26.78v.13c0,3.43-2.6,6.2-7,6.2s-7.03-2.84-7.03-7.33v-4.57c0-4.56,2.57-7.4,7.03-7.4s7,2.63,7,7.23v3.67h-9.7v2.03c0,1.67,1.33,2.8,2.7,2.8,1.47,0,2.67-.83,2.67-2.37v-.4h4.33ZM127.52,21.64h5.37v-.9c0-2.5-1.03-3.33-2.67-3.33-1.53,0-2.7.87-2.7,2.87v1.37Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M143.48,32.77h-4.33V14.04h4.07v1.93c.23-.5,1.33-2.13,3.86-2.13,1.9,0,3.5.8,4.4,2.57.57-1.1,2.07-2.57,4.6-2.57,3.13,0,4.96,2.03,4.96,6.57v12.36h-4.36v-12.53c0-1.87-1-2.57-2.2-2.57-1.13,0-2.2.73-2.2,2.5v12.6h-4.37v-12.53c0-1.83-.93-2.57-2.23-2.57-1.13,0-2.2.7-2.2,2.5v12.6Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M167.48,32.77h-4.33V14.04h4.07v1.93c.23-.5,1.33-2.13,3.86-2.13,1.9,0,3.5.8,4.4,2.57.57-1.1,2.07-2.57,4.6-2.57,3.13,0,4.97,2.03,4.97,6.57v12.36h-4.37v-12.53c0-1.87-1-2.57-2.2-2.57-1.13,0-2.2.73-2.2,2.5v12.6h-4.37v-12.53c0-1.83-.93-2.57-2.23-2.57-1.13,0-2.2.7-2.2,2.5v12.6Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M186.86,26.14v-5.43c0-4.83,2.27-6.9,5.53-6.9,2.73,0,4.17,1.73,4.43,2.33v-2.1h4.07v18.73h-4.07v-2.07c-.27.63-1.7,2.37-4.43,2.37-3.33,0-5.53-2.13-5.53-6.93ZM196.56,25.81v-4.83c0-2.27-1.13-3.27-2.67-3.27s-2.67,1.03-2.67,3.33v4.77c0,2.33,1.07,3.37,2.67,3.37s2.67-1.07,2.67-3.37Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M205.5,33.04c-1.47,0-2.63-1.17-2.63-2.63s1.16-2.66,2.63-2.66,2.63,1.2,2.63,2.66-1.17,2.63-2.63,2.63Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M223.23,20.11h-4.23c0-2.1-1.13-2.67-2.73-2.67-1.5,0-2.37.67-2.37,1.8,0,3.5,9.53,1.8,9.53,8.3,0,3.63-2.47,5.66-7,5.66s-7.23-2.47-7.23-6.63h4.33c0,2.07,1.23,2.93,2.9,2.93s2.63-.93,2.63-2c0-3.26-9.43-1.66-9.43-8.27,0-3.43,2.47-5.53,6.6-5.53,4.5,0,7,2.13,7,6.4Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M238.77,26.78v.13c0,3.43-2.6,6.2-7,6.2s-7.03-2.84-7.03-7.33v-4.57c0-4.56,2.57-7.4,7.03-7.4s7,2.63,7,7.23v3.67h-9.7v2.03c0,1.67,1.33,2.8,2.7,2.8,1.47,0,2.67-.83,2.67-2.37v-.4h4.33ZM229.07,21.64h5.37v-.9c0-2.5-1.03-3.33-2.67-3.33-1.53,0-2.7.87-2.7,2.87v1.37Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M14.29,17.62h.08c1.61-2.12,3.77-3.69,6.83-3.69,3.45,0,5.57,2.16,5.57,5.49v9.3c0,4.11-5.13,4.16-5.13,4.16h-2.38v-2.59h1.32c1.1,0,1.57-.43,1.57-1.57v-8.98c0-2-1.37-2.75-3.45-2.75s-4.39,2.16-4.39,5.61v6.12c0,1.14.47,1.57,1.57,1.57h.5v2.59H7.37v-2.59h.72c1.1,0,1.57-.43,1.57-1.57V11.22c0-1.14-.47-1.57-1.57-1.57h-.72v-2.59h6.92v10.56Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M35.33,39.98H0V0h35.33v39.98ZM2.3,37.69h30.72V2.28H2.3v35.41Z"
      />
      <path
        fill="#1d1d1b"
        strokeWidth="0px"
        d="M29.1,32.03c-.02.12-.06.23-.12.34-.06.11-.13.2-.22.27-.09.07-.21.13-.35.17-.15.04-.31.06-.5.06s-.36-.02-.5-.06c-.14-.04-.26-.1-.35-.17-.09-.07-.16-.16-.22-.27-.06-.11-.1-.22-.12-.34-.02-.12-.03-.25-.03-.39s.01-.27.03-.38c.02-.12.06-.23.12-.34.06-.11.13-.2.22-.27.09-.07.21-.13.35-.17.15-.04.31-.06.5-.06.24,0,.44.03.6.1.16.06.29.15.38.27.09.12.15.25.19.39.04.14.06.3.06.48,0,.14-.01.27-.03.39ZM28.8,31.25c-.03-.11-.08-.21-.15-.3-.07-.09-.16-.16-.29-.21-.12-.05-.28-.07-.45-.07s-.33.02-.45.07c-.12.05-.22.12-.29.21-.07.09-.12.19-.15.3-.03.11-.05.24-.05.39s.01.28.04.39c.03.11.08.21.15.3.07.09.17.16.29.21.12.05.28.07.45.07s.33-.02.45-.07c.13-.05.22-.12.29-.21.07-.09.12-.19.15-.3.03-.11.04-.24.04-.39s-.02-.28-.04-.39ZM28.11,32.28l-.43-.46v.46h-.27v-1.26h.49c.12,0,.22.01.3.04.08.02.14.06.18.1.04.04.06.09.07.13.01.04.02.09.02.14,0,.24-.14.36-.42.36h-.11l.55.49h-.38ZM27.91,31.23h-.23v.38h.24c.06,0,.11,0,.15-.02.04-.01.07-.03.09-.05.02-.02.03-.04.03-.06,0-.02,0-.04,0-.06,0-.13-.1-.19-.28-.19Z"
      />
    </g>
  </svg>
);
